// we can change the location of this file if requires

const parseAge = (value) => {
  // age is string
  let pargedAge = null;
  if (value) {
    let age = value.toString().trim();
    if(age.includes('>') || age.includes('<')) age = age.substr(1);
    pargedAge = parseInt(age);
  }
  return pargedAge;
}

const monthObj = {
  'Jan': 1,
  'Feb': 2,
  'Mar': 3,
  'Apr': 4,
  'May': 5,
  'Jun': 6,
  'Jul': 7,
  'Aug': 8,
  'Sep': 9,
  'Oct': 10,
  'Nov': 11,
  'Dec': 12
}

const convertTime = (value) => {
  // console.log(value, "VALUE")
  if(value) {

    let timeArr = value + ''.split(', ');
    let dateArr = timeArr[0] + ''.split(' ');
    return `${monthObj[dateArr[0]]}/${dateArr[1]}/${timeArr[1]}`;
  }
}

const validateValue = (type, value, valueToCompare) => {
  // console.log('validateValue type => ', type, 'value => ', value, 'value to compare => ' , valueToCompare);
  let validationError = null;
  if (type === 'minAge') {
    let minAge = parseAge(value);
    let maxAge = parseAge(valueToCompare);
    // console.log(minAge, maxAge, "MIN AGE")
    if (minAge < 0 || minAge > 1200 ) {
      validationError = 'Minimum age must be between 0 and 1200';
    } else if (maxAge && minAge > maxAge && valueToCompare !== '>75') {
      validationError = 'Minimum age must be less than maximum age';
    }
  } else if (type === 'maxAge') {
    let maxAge = parseAge(value);
    let minAge = parseAge(valueToCompare);
    // console.log(minAge, maxAge, "MAX AGE")
    if (maxAge < 0 || maxAge > 1200 ) {
      validationError = 'Maximum age must be between 0 and 1200';
    } else if (minAge && minAge > maxAge && valueToCompare !== '<1') {
      validationError = 'Maximum age must not be less than minimum age';
    }
  } else if (type === 'mutationsIN') {
    let matchedMutations = [];
    value.forEach(element => {
      if(valueToCompare.includes(element)) matchedMutations.push(element);
    });
    if(matchedMutations.length > 0) validationError = `'Eligible Mutations: ${matchedMutations.join(', ')}' are/is already available in 'Not Eligible Mutations'`;
  } else if (type === 'mutationsOUT') {
    let matchedMutations = [];
    value.forEach(element => {
      if(valueToCompare.includes(element)) matchedMutations.push(element);
    });
    if(matchedMutations.length > 0) validationError = `'Not Eligible Mutations: ${matchedMutations.join(', ')}' are/is already available in 'Eligible Mutations'`;
  } else if (type === 'startDate' && valueToCompare !== '') {
    let startDate = Date.parse(convertTime(value));
    let endDate = valueToCompare ? Date.parse(convertTime(valueToCompare)) : 0;
    if (endDate < startDate) validationError = "Start Date can't be more than End Date"
  } else if (type === 'endDate' && valueToCompare !== '') {
    let startDate = valueToCompare ? Date.parse(convertTime(valueToCompare)) : 0;
    let endDate = Date.parse(convertTime(value));
    if (endDate < startDate) validationError = "End Date can't be less than Start Date"
  }
  return validationError;
}

export { validateValue };
